import { useState } from "react";
import { Form, Radio, RadioChangeEvent, Spin } from "antd";
import { useHistory } from "react-router-dom";

import { withProcedureWraper } from "../../../..";
import styles from "./EmployeeConfirmationCreate.module.scss";

import { Button } from "../../../../../../modules/button";
import {
  CreateECEnglishForm as CreateECEnForm,
  CreateECVietnameseForm as CreateECViForm,
} from "../../components";

enum Language {
  vi = "vi",
  en = "en",
}

const EmployeeConfirmationCreate = withProcedureWraper(() => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [language, setLanguage] = useState<Language>(Language.vi);

  const isViLanguage = language === Language.vi;

  return (
    <Spin spinning={false}>
      <Form form={form} size="large" layout="vertical">
        <div className={styles.container}>
          <div className={styles.header}>
            <h2 className={styles.title}>
              {isViLanguage ? "Giấy chứng nhận" : "Letter of certification"}
            </h2>
            <Radio.Group
              value={language}
              onChange={(e: RadioChangeEvent) => setLanguage(e.target.value)}
            >
              <Radio.Button value={Language.vi}>
                {isViLanguage ? "Tiếng Việt" : "Vietnamese"}
              </Radio.Button>
              <Radio.Button value={Language.en}>
                {isViLanguage ? "Tiếng Anh" : "English"}
              </Radio.Button>
            </Radio.Group>
          </div>
          <div className={styles.content}>
            {isViLanguage ? <CreateECViForm /> : <CreateECEnForm />}
          </div>
          <div className={styles.footer}>
            <Button
              type="submit"
              label={isViLanguage ? "Xác nhận" : "Confirm"}
            />
            <Button
              type="button"
              label={isViLanguage ? "Huỷ" : "Cancel"}
              buttonType="danger-outline"
              className="ml10"
              onClick={() => history.goBack()}
            />
          </div>
        </div>
      </Form>
    </Spin>
  );
});

export default EmployeeConfirmationCreate;
